import React, { useMemo, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppInsightsContext, useTrackEvent } from '@microsoft/applicationinsights-react-js';
import { DvrOutlined, InfoOutlined, OpenInNewOutlined } from '@mui/icons-material';
import DashboardCard, { CardHeader } from '../DashboardCard/DashboardCard';
import configs from '../../../../config.json';

export default function OnboardingCard({ portalUrl = configs.REACT_APP_TIFO_URL }) {
  return (
    <DashboardCard animDelay={animDelay}>
      <CardHeader icon={<DvrOutlined />} title={t('dashboard.cards.onboarding')} />
      <div className="px-5 pb-5 flex flex-col gap-3">
        <div className="flex gap-3 bg-[#E6F4F8] rounded-[10px] p-4 border border-[#C5E4EE]">
          <InfoOutlined sx={{ fontSize: 17, color: '#0094B3', flexShrink: 0, marginTop: '1px' }} />
          <p className="text-[14px] text-[#1A2B35] leading-relaxed m-0">
            {t('dashboard.onboarding.description')}
          </p>
        </div>

        {lastOpenedLabel && (
          <p className="text-[12px] text-[#6B7A85] m-0">
            {t('dashboard.onboarding.lastopened', { when: lastOpenedLabel })}
          </p>
        )}

        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleOpen('primary')}
          aria-label={t('dashboard.onboarding.openaria')}
          className="flex items-center justify-center gap-2 w-full py-3 bg-[#0094B3] text-white text-[15px] font-semibold rounded-[8px] no-underline hover:bg-[#0081A0] transition-colors duration-150"
        >
          {t('dashboard.onboarding.openbutton')}
          <OpenInNewOutlined sx={{ fontSize: 16 }} />
        </a>

        <p className="text-[12px] text-[#6B7A85] text-center m-0">
          {t('dashboard.onboarding.fallbackprompt')}{' '}
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleOpen('fallback')}
            aria-label={t('dashboard.onboarding.fallbackaria')}
            className="text-[#0094B3] font-medium underline"
          >
            {t('dashboard.onboarding.fallbacklink')}
          </a>
        </p>
      </div>
    </DashboardCard>
  );
}